import { t } from '@lingui/core/macro';
import { AclAction } from 'shared/domains/apollo/generated/types';
export const getAccessLevelName = (actions) => {
    if (actions.includes(AclAction.Write)) {
        return t({ message: 'Editor', comment: 'Access level name' });
    }
    if (actions.includes(AclAction.Read)) {
        return t({ message: 'Viewer', comment: 'Access level name' });
    }
    if (actions.includes(AclAction.Traverse)) {
        return t({ message: 'Partial access', comment: 'Access level name' });
    }
    return t({ message: 'No access', comment: 'Access level name' });
};
